import React, { useState } from 'react';
import img3 from '../../assets/image/img-3.jpg';
import { sendContact } from '../../utils/apiService';

const Contact = () => {
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        message: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', message: '' });

        const result = await sendContact(formData);

        if (result && result.status) {
            setStatus({ type: 'msg-success', message: result.message || 'Thank you for contacting us.' });
            setFormData({
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                message: ''
            });
        } else {
            setStatus({ type: 'msg-error', message: result.message || 'Something went wrong. Please try again.' });
        }
        setLoading(false);
    };

    return (
        <section className="section-form tf-spacing-4">
            <div className="section-inner flex">
                <div className="left">
                    <div className="image tf-animate-1">
                        <img src={img3} alt="" />
                    </div>
                    <div className="section-content section-form-content">
                        <div className="sub-title body-2 fw-7 mb-17">
                            Work Inquiry
                        </div>
                        <div
                            className="title fw-6 mb-0 title-animation"
                            dangerouslySetInnerHTML={{
                                __html: "Are you ready to scale your business?"
                            }}
                        />
                    </div>
                </div>
                <div className="right">
                    <form onSubmit={handleSubmit} id="contactform" className="form-contact-us px-md-15 homecontact">
                        {status.message && (
                            <div className={`flat-alert mb-20 ${status.type}`}>
                                {status.message}
                            </div>
                        )}
                        <div className="heading-form text-center">
                            <h3 className="title">
                                Need Help For Project!
                            </h3>
                            <div className="desc lh-30">Get in touch and let us build something amazing together!</div>
                        </div>

                        <div className="cols mb-20 g-20">
                            <fieldset className="item">
                                <input
                                    type="text"
                                    name="firstname"
                                    placeholder="First Name"
                                    value={formData.firstname}
                                    onChange={handleChange}
                                    required
                                />
                                <i className="icon-user"></i>
                            </fieldset>

                            <fieldset className="item">
                                <input
                                    type="text"
                                    name="lastname"
                                    placeholder="Last Name"
                                    value={formData.lastname}
                                    onChange={handleChange}
                                    required
                                />
                                <i className="icon-user"></i>
                            </fieldset>
                        </div>

                        <div className="cols mb-20 g-20">
                            <fieldset className="item">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                                <i className="icon-email"></i>
                            </fieldset>

                            <fieldset className="item">
                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="Phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                                <i className="icon-phone"></i>
                            </fieldset>
                        </div>

                        <fieldset className="mb-20">
                            <textarea
                                name="message"
                                placeholder="Message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </fieldset>

                        <button type="submit" className="tf-btn mx-auto" disabled={loading}>
                            <span>{loading ? 'Sending...' : 'Send Message Us'}</span>
                            {!loading && <i className="icon-arrow-right"></i>}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Contact;
